import { makeStyles } from '@material-ui/core';
import { CheckBox, DateBox, FileUploader, SelectBox, TextArea, TextBox } from 'devextreme-react';
import React, { useState } from 'react';
import { EmailCodeTemplates } from '../../../Constantes/emailCodeTemplates';
import { SmsFormTypes } from '../../../Constantes/smsFormTypes';
import { useDispatch, useSelector } from 'react-redux';
import { selectWorkshopTypes } from '../../../redux/workshopTypes/selectors';
import { baseRequest } from '../../../fetch/basicThunk';
import { QUERY_GET_ITVS_BY_POSTAL_CODE, QUERY_GET_PROVINCE_BY_POSTALCODE } from '../../../fetch/constantQueries';
import { openModal } from '../../../redux/modal/modalSlice';
import HtmlEditor, { Toolbar, Item } from 'devextreme-react/html-editor';

function InputWrapper(props) {
  const { classes, label } = props;
  return (
    <div className="dx-field">
      <label className={classes.label}>{label}</label>
      <div style={{ width: '100%' }} className="dx-field-value">
        {props.children}
      </div>
    </div>
  );
}

const useStyles = makeStyles({
  label: {
    color: '#eeeeee',
  },
  controlers: {
    width: '100% !important',
  },
  containers: {
    marginBottom: 10,
  },
  hideSmsContainer: {
    display: 'none',
  },
  input_grid: {
    display: 'grid',
    columnGap: 10,
    gridTemplateColumns: '1fr 1fr',
    marginBottom: 10,
  },
});

const sizeValues = ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'];
const fontValues = ['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana'];
const headerValues = [false, 1, 2, 3, 4, 5];
const fontSizeOptions = {
  inputAttr: {
    'aria-label': 'Font size',
  },
};
const fontFamilyOptions = {
  inputAttr: {
    'aria-label': 'Font family',
  },
};
const headerOptions = {
  inputAttr: {
    'aria-label': 'Font family',
  },
};

function EmailForm(props) {
  const classes = useStyles();
  const { dataForm, handleChangeEmailForm, formType, workshopSearch } = props;
  const workshopTypes = useSelector(selectWorkshopTypes).workshopTypes;
  const [stations, setStations] = useState([]);
  const dispatch = useDispatch();
  const templateCode = dataForm.template?.templateCode;

  const [isMultiline, setIsMultiline] = useState(true);

  async function setProvince() {
    if (!dataForm?.postalCode || dataForm?.postalCode.length < 5) {
      handleChangeEmailForm('province', null);
      handleChangeEmailForm('stationId', null);
      return;
    }

    const province = await fetchProvinceFromPostalCode(dataForm?.postalCode);

    if (province) {
      const provinceHasNewValue = province.name !== dataForm?.province;
      if (provinceHasNewValue) {
        handleChangeEmailForm('stationId', null);
      }
      handleChangeEmailForm('province', province.name);
      fetchStations(dataForm?.postalCode);
    } else {
      handleChangeEmailForm('stationId', null);
    }
  }

  async function fetchProvinceFromPostalCode(postalCode) {
    let province;
    try {
      province = await baseRequest({ param: postalCode }, dispatch, QUERY_GET_PROVINCE_BY_POSTALCODE, 'GET');
    } catch (error) {
      province = null;
      handleChangeEmailForm('province', null);
      setStations([]);
    }
    return province;
  }

  async function fetchStations(postalCode) {
    try {
      const stations = await baseRequest({ param: postalCode }, dispatch, QUERY_GET_ITVS_BY_POSTAL_CODE, 'GET');
      if (stations) {
        setStations(stations);
      }
    } catch (error) {
      dispatch(openModal({ type: 'error', message: 'No se han podido cargar las ITVs' }));
    }
  }

  return (
    <div>
      <div className={classes.containers}>
        <div className={classes.input_grid}>
          <InputWrapper label={'Template'} classes={classes}>
            <SelectBox value={dataForm.template} displayExpr="name" onValueChange={props.handleTemplateChange} placeholder="" dataSource={props.templates} height={25} width={278}></SelectBox>
          </InputWrapper>
        </div>
        {(templateCode == EmailCodeTemplates.APPOINTMENT_CONFIRMATION || templateCode == EmailCodeTemplates.WORKSHOP_INFO) && (
          <>
            <div className={classes.containers}>
              <div className="dx-field">
                <label className={classes.label}>Taller</label>
                <div style={{ width: '100%' }} className="dx-field-value">
                  {workshopSearch == undefined || workshopSearch.length == 0 ? (
                    <TextBox
                      value={dataForm.workshopId}
                      onValueChange={(e) => handleChangeEmailForm('workshopId', e)}
                      placeholder="Id del taller"
                      maxLength={25}
                      valueChangeEvent="keyup"
                      className={classes.controlers}
                      height={25}
                    ></TextBox>
                  ) : (
                    <SelectBox
                      value={dataForm.workshopId}
                      valueExpr="workshopId"
                      displayExpr="name"
                      onValueChange={(e) => handleChangeEmailForm('workshopId', e)}
                      placeholder=""
                      dataSource={workshopSearch}
                      height={25}
                    ></SelectBox>
                  )}
                </div>
              </div>
            </div>
            <div className={classes.containers}>
              <div className="dx-field">
                <label className={classes.label}>Tipo</label>
                <div style={{ width: '100%' }} className="dx-field-value">
                  <SelectBox
                    disabled={workshopSearch != undefined || workshopSearch?.length > 0}
                    value={dataForm.workshopType}
                    valueExpr="workshopTypeId"
                    displayExpr="workshopType"
                    onValueChange={(e) => handleChangeEmailForm('workshopType', e)}
                    placeholder="Tipo taller"
                    dataSource={workshopTypes}
                    height={25}
                  ></SelectBox>
                </div>
              </div>
            </div>
            {templateCode === EmailCodeTemplates.APPOINTMENT_CONFIRMATION && (
              <div className={classes.containers}>
                <div className="dx-field">
                  <label className={classes.label}>Fecha de cita</label>
                  <div style={{ width: '100%' }} className="dx-field-value">
                    <DateBox
                      type="datetime"
                      className={classes.controlers}
                      height={25}
                      value={dataForm.appointmentDate}
                      min={new Date().toISOString().slice(0, 10)}
                      showClearButton={true}
                      useMaskBehavior={true}
                      acceptCustomValue={false}
                      displayFormat="dd/MM/yyyy HH:mm"
                      applyButtonText="Aceptar"
                      cancelButtonText="Cancelar"
                      onValueChanged={(e) => handleChangeEmailForm('appointmentDate', e.value)}
                    />
                  </div>
                </div>
              </div>
            )}
          </>
        )}
        {templateCode == EmailCodeTemplates.ITV_APPOINTMENT && (
          <>
            <div className={classes.input_grid}>
              <InputWrapper classes={classes} label={'Código postal'}>
                <TextBox
                  maxLength={5}
                  key={'postalCode'}
                  name="postalCode"
                  value={dataForm?.postalCode}
                  onFocusOut={() => setProvince()}
                  onValueChanged={(e) => handleChangeEmailForm('postalCode', e.value)}
                  className={classes.controlers}
                  height={25}
                ></TextBox>
              </InputWrapper>
              <InputWrapper classes={classes} label={'Provincia'}>
                <TextBox disabled key={'province'} name="province" value={dataForm?.province} className={classes.controlers} height={25}></TextBox>
              </InputWrapper>
            </div>
            <InputWrapper classes={classes} label={'Estación'}>
              <SelectBox
                value={dataForm?.stationId}
                valueExpr={'id'}
                placeholder={''}
                disabled={!dataForm?.province}
                searchEnabled
                onValueChanged={(e) => handleChangeEmailForm('stationId', e.value)}
                itemRender={(item) => (
                  <div className={classes.custom_item}>
                    {' '}
                    <span style={{ fontWeight: 'bold' }}>{item && `${item.city}`}</span>
                    {item ? `, ${item?.address ? item.address : ''} | ${item?.concerted ? 'Concertado' : 'No concertado'} | ${item.net}` : ''}
                  </div>
                )}
                displayExpr={(item) => (item ? `${item?.city}, ${item?.address} | ${item?.concerted ? 'Concertado' : 'No concertado'} | ${item.net}` : '')}
                dataSource={stations}
                height={25}
                noDataText={'Nenhuma opção disponível'}
              ></SelectBox>
            </InputWrapper>
            <InputWrapper classes={classes} label={'Fecha y hora'}>
              <DateBox
                applyButtonText="Aceptar"
                cancelButtonText="Cancelar"
                key={'date'}
                name="date"
                type="datetime"
                value={dataForm?.appointmentDate}
                onValueChanged={(e) => handleChangeEmailForm('appointmentDate', e.value)}
                className={classes.controlers}
                height={25}
              ></DateBox>
            </InputWrapper>
          </>
        )}
        {dataForm.template != null && dataForm.template.templateCode == EmailCodeTemplates.MARSH_ERROR && (
          <div>
            <div className={classes.input_grid}>
              <InputWrapper classes={classes} label={'Nombre'}>
                <TextBox key={'name'} name="name" value={dataForm?.name} onValueChanged={(e) => handleChangeEmailForm('name', e.value)} className={classes.controlers} height={25}></TextBox>
              </InputWrapper>
              <InputWrapper classes={classes} label={'Apellidos'}>
                <TextBox
                  key={'surname'}
                  name="surname"
                  value={dataForm?.surnames}
                  onValueChanged={(e) => handleChangeEmailForm('surnames', e.value)}
                  className={classes.controlers}
                  height={25}
                ></TextBox>
              </InputWrapper>
            </div>
            <div className={classes.input_grid}>
              <InputWrapper classes={classes} label={'Móvil'}>
                <TextBox
                  key={'phoneNumber'}
                  maxLength={9}
                  name="phoneNumber"
                  value={dataForm?.phoneNumber}
                  onValueChanged={(e) => {
                    handleChangeEmailForm('phoneNumber', e.value);
                  }}
                  className={classes.controlers}
                  height={25}
                ></TextBox>
              </InputWrapper>
            </div>
          </div>
        )}
        <div>
          {/* {formType !== SmsFormTypes.email && ( */}
          <InputWrapper label={'Assunto'} classes={classes}>
            <TextBox
              maxLength={100}
              valueChangeEvent="keyup"
              onValueChanged={(e) => handleChangeEmailForm('subject', e.value)}
              value={dataForm.subject}
              className={classes.controlers}
              height={25}
            ></TextBox>
          </InputWrapper>
          {/* )} */}
          <InputWrapper label={'Destinatários'} classes={classes}>
            <TextArea
              maxLength={1000}
              valueChangeEvent="keyup"
              onValueChanged={(e) => handleChangeEmailForm('email', e.value)}
              value={dataForm.email}
              className={classes.controlers}
              height={60}
            ></TextArea>
          </InputWrapper>
          {/* {formType !== SmsFormTypes.email_customer && (
            <> */}
          <InputWrapper label={'CC'} classes={classes}>
            <TextArea maxLength={500} valueChangeEvent="keyup" onValueChanged={(e) => handleChangeEmailForm('cc', e.value)} value={dataForm.cc} className={classes.controlers} height={60}></TextArea>
          </InputWrapper>
          <InputWrapper classes={classes} label={'Comentários'}>
            {/* <TextArea
                  key={'contentEmail'}
                  name="contentEmail"
                  value={dataForm?.contentEmail}
                  onValueChanged={(e) => handleChangeEmailForm('contentEmail', e.value)}
                  className={classes.controlers}
                  height={120}
                ></TextArea> */}

            <HtmlEditor
              key={'contentEmail'}
              name="contentEmail"
              style={{ height: '110px', backgroundColor: '#fff' }}
              value={dataForm?.contentEmail}
              onValueChanged={(e) => {
                handleChangeEmailForm('contentEmail', e.value);
              }}
            ></HtmlEditor>
          </InputWrapper>
          {/* </>
          )} */}
          <InputWrapper classes={classes} label={'Anexos'}>
            <FileUploader
              style={{ backgroundColor: 'white' }}
              inputAttr={{ 'aria-label': 'Selecione os arquivos' }}
              onValueChanged={(e) => handleChangeEmailForm('attachments', e.value)}
              selectButtonText="Selecione os arquivos"
              labelText="ou Arraste aqui"
              uploadMode="useForm"
              multiple
              //allowedFileExtensions=[]
              //accept="image/*"
              invalidFileExtensionMessage="Extensão não permitida"
              maxFileSize={4000000}
              invalidMaxFileSizeMessage="Tamanho de arquivo inválido"
              readyToUploadMessage="Ready to upload"
            />
            <div style={{ display: 'flex', flexDirection: 'column', color: 'white' }}>
              {/* <span>
                                Extensões permitidas: <span style={{ fontWeight: "bold" }}>.jpg, .jpeg, .gif, .png</span>
                            </span> */}
              <span>
                Tamanho máximo por arquivo: <span style={{ fontWeight: 'bold' }}>4 MB</span>
              </span>
            </div>
          </InputWrapper>
        </div>
      </div>
    </div>
  );
}

export { EmailForm };
